export default {
  authority: "https://account.headpower.fi/identity",
  clientId: "edilex",
  redirectUri: `https://${window.location.hostname}/auth/login-callback`,
  responseType: "id_token token",
  scope: "openid profile email headpower:api",
}
